import React from "react";

import { Box } from "@mui/material";

const HomeBackground = (props) => {
  return (
    <Box sx={styledBg} className="for-background">
      {props.children}
    </Box>
  );
};

export default HomeBackground;

const styledBg = {
  height: "auto",
  backgroundImage:
    "linear-gradient(90deg, #1A202B 10%, rgba(17, 38, 56, 0.6) 52.08%, #1A202B 79.63%)",
  marginTop: "700px",
  position: "relative",
  zIndex: 1,
  paddingBottom: 10,
  width: "100vw",
};
